import React from 'react';
import Shortcuts from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcuts/index.tsx';
import { useKeyMap } from './utils/index.tsx';

const KeyboardShortcuts = () => {
	const keyMap = useKeyMap();

	return <Shortcuts keyMap={keyMap} location="software.backlog.keyboard-shortcuts" />;
};

export default KeyboardShortcuts;
